import allPaths from '../Config/paths'
import service1 from '../fifthAssets/Images/service-1.jpg'
import service2 from '../fifthAssets/Images/service-2.jpg'
import service3 from '../fifthAssets/Images/service-3.jpg'
import service4 from '../fifthAssets/Images/service-4.jpg'
import service5 from '../fifthAssets/Images/service-5.jpg'
import service6 from '../fifthAssets/Images/service-6.jpg'
import service7 from '../fifthAssets/Images/service-7.jpg'
import service8 from '../fifthAssets/Images/service-8.jpg'
import service9 from '../fifthAssets/Images/service-9.jpg'
import news1 from '../fifthAssets/Images/news-1.jpg'
import news2 from '../fifthAssets/Images/news-2.jpg'
import news3 from '../fifthAssets/Images/news-3.jpg'
import news4 from '../fifthAssets/Images/news-4.jpg'
import news5 from '../fifthAssets/Images/news-5.jpg'
import news6 from '../fifthAssets/Images/news-6.jpg'
import news7 from '../fifthAssets/Images/news-7.jpg'
import news8 from '../fifthAssets/Images/news-8.jpg'
import news9 from '../fifthAssets/Images/news-9.jpg'
import news10 from '../fifthAssets/Images/news-10.jpg'
import about1 from '../fifthAssets/Images/about-1.jpg'
import about2 from '../fifthAssets/Images/about-2.jpg'
import about3 from '../fifthAssets/Images/about-3.jpg'
import about4 from '../fifthAssets/Images/about-4.jpg'
import about5 from '../fifthAssets/Images/about-5.jpg'
import about6 from '../fifthAssets/Images/about-6.jpg'
import doctor1 from '../fifthAssets/Images/dr-1.jpeg'
import doctor2 from '../fifthAssets/Images/dr-2.jpeg'
import doctor3 from '../fifthAssets/Images/dr-3.jpeg'
import doctor4 from '../fifthAssets/Images/dr-4.jpeg'
import doctor5 from '../fifthAssets/Images/dr-5.jpeg'
import doctor6 from '../fifthAssets/Images/dr-6.jpg'
import doctor7 from '../fifthAssets/Images/dr-7.jpg'
import doctor8 from '../fifthAssets/Images/dr-8.jpg'
import rehabilitation1 from '../fifthAssets/Images/rehabilitation-1.jpg'
import rehabilitation2 from '../fifthAssets/Images/rehabilitation-2.jpg'
import rehabilitation3 from '../fifthAssets/Images/rehabilitation-3.jpg'
import rehabilitation4 from '../fifthAssets/Images/rehabilitation-4.jpg'
import rehabilitation5 from '../fifthAssets/Images/rehabilitation-5.jpg'
import neurology1 from '../fifthAssets/Images/neurology-1.jpg'
import neurology2 from '../fifthAssets/Images/neurology-2.jpg'
import neurology3 from '../fifthAssets/Images/neurology-3.jpg'

const menuItems = [
    {
        menuName: 'Home',
        menuALName: 'الرئيسية',
        menuGLName: 'Startseite',
        menuRoute: allPaths?.FIFHTHOME,
    },
    {
        menuName: 'About',
        menuALName: 'معلومات',
        menuGLName: 'Über uns',
        menuRoute: allPaths?.FIFHTABOUT,
        submenu: [
            { name: 'Who we are', glName: 'Wer wir sind', alName: 'من نحن', route: allPaths?.FIFHTWHOWEARE },
            { name: 'Our Mission & Vision', glName: 'Unsere Mission & Vision', alName: 'مهمتنا ورؤيتنا', route: allPaths?.FIFHTMISSIONANDVISION },
            { name: 'Our Core Values', glName: 'Unsere Kernwerte', alName: 'قيمنا الأساسية', route: allPaths?.FIFHTCOREVALUES },
            { name: 'Our Team', glName: 'Unser Team', alName: 'فريقنا', route: allPaths?.FIFHTOURTEAMS },
            { name: 'Testimonials', glName: 'Kundenstimmen', alName: 'الشهادات - التوصيات', route: allPaths?.FIFHTTESTIMONIALS },
            { name: 'Careers', glName: 'Karriere', alName: 'الوظائف', route: allPaths?.FIFHTCAREERS },
        ],
    },
    {
        menuName: 'Your Health & Our Specialities',
        menuALName: 'صحتك وتخصصاتنا',
        menuGLName: 'Ihre Gesundheit & Unsere Spezialitäten',
        menuRoute: allPaths?.FIFHTSPECIALITIES,
        submenu: [
            { name: 'Physiotherapy & Orthopedic', glName: 'Physiotherapie & Orthopädie', alName: 'العلاج الطبيعي والعظام', route: allPaths?.FIFHTOURTPHYSIOTHERAPYORTHOPEDIC },
            { name: 'Rehabilitation', glName: 'Rehabilitation', alName: 'إعادة التأهيل', route: allPaths?.FIFHTOURTREHABILITATION },
            { name: 'Neurology Centre of Expertise', glName: 'Neurologie-Kompetenzzentrum', alName: 'مركز الخبرة في طب الأعصاب', route: allPaths?.FIFHTNEUROLOGYCENTRE },
            { name: 'Pediatric Rehabilitation Program', glName: 'Pädiatrisches Rehabilitationsprogramm', alName: 'برنامج إعادة التأهيل للأطفال', route: allPaths?.FIFHTPEDIATRIC },
        ],
    },
    {
        menuName: 'Our Centres of Expertise',
        menuALName: 'مراكز خبرتنا',
        menuGLName: 'Unsere Kompetenzzentren',
        menuRoute: allPaths?.FIFHTEXPERTIES,
        submenu: [
            { name: 'Back Centre of Expertise', glName: 'Rückenzentrum der Expertise', alName: 'مركز الخلفي للخبرة', route: allPaths?.FIFHTCENTREEXPERTIES },
            { name: 'Foot Lab & Gait Analysis Centre of Expertise', glName: 'Fußlabor & Ganganalysezentrum', alName: 'مختبر القدم ومركز تحليل المشية', route: allPaths?.FIFHTFOOTLAB },
            { name: 'Neurology Centre of Expertise', glName: 'Neurologisches Kompetenzzentrum', alName: "مركز الخبرة في طب الأعصاب", route: allPaths?.FIFHTNEUROLOGYCENTRE },
            { name: 'Knee Centre of Expertise', glName: 'Kniespezialzentrum', alName: 'مركز الخبرة في علاج الركبة', route: allPaths?.FIFHTKNEECENTREOFEXPERTISE },
        ],
    },
    {
        menuName: 'News',
        menuALName: 'أخبارنا',
        menuGLName: 'Neuigkeiten',
        menuRoute: allPaths?.FIFHTLATESTNEWS,
    },
    {
        menuName: 'Contact Us',
        menuALName: 'اتصل بنا',
        menuGLName: 'Kontaktieren Sie uns',
        menuRoute: allPaths?.FIFHTCONTACT,
    },
    {
        menuName: 'Content Form',
        menuALName: 'نموذج المحتوى',
        menuGLName: 'Inhaltsformular',
        menuRoute: allPaths?.FIFHTCONTENTFORM,
    },
];

const serviceData = [
    {
        img: service1,
        title: "PHYSIOTHERAPY & ORTHOPEDIC",
        text: "Our Back, Knee, and Shoulder Centres of Expertise offer specialized care with advanced techniques to restore mobility, strength, and functionality, helping you lead a pain-free life...",
        alTitle: "العلاج الطبيعي وجراحة العظام",
        glTitle: "Physiotherapie & Orthopädie",
        alText: "تقدم مراكزنا المتخصصة للظهر والركبة والكتف رعاية متخصصة بتقنيات متقدمة لاستعادة الحركة والقوة والوظائف، مما يساعدك على عيش حياة خالية من الألم...",
        glText: "Unsere Rück-, Knie- und Schulterkompetenzzentren bieten spezialisierte Pflege mit fortschrittlichen Techniken, um Mobilität, Kraft und Funktionalität wiederherzustellen, damit Sie ein schmerzfreies Leben führen können...",
        link: allPaths?.FIFHTOURTPHYSIOTHERAPYORTHOPEDIC
    },
    {
        img: service2,
        title: "REHABILITATION PROGRAM",
        text: "Our COPD, Diabetics, and Geriatrics programs offer specialized care with advanced techniques to enhance health, manage symptoms, and improve quality of life...",
        alTitle: "برنامج إعادة التأهيل",
        glTitle: "Rehabilitationsprogramm",
        alText: "تقدم برامجنا لمرضى الانسداد الرئوي المزمن والسكري وكبار السن رعاية متخصصة بتقنيات متقدمة لتعزيز الصحة وإدارة الأعراض وتحسين جودة الحياة...",
        glText: "Unsere COPD-, Diabetes- und Geriatrieprogramme bieten spezialisierte Pflege mit fortschrittlichen Techniken, um die Gesundheit zu verbessern, Symptome zu verwalten und die Lebensqualität zu steigern...",
        link: allPaths?.FIFHTOURTREHABILITATION
    },
    {
        img: service3,
        title: "NEUROLOGY CENTRE OF EXPERTISE",
        text: "Our Multiple Sclerosis, Parkinson’s, and Stroke programs provide specialized care with advanced techniques to enhance health, manage symptoms, and improve quality of life...",
        alTitle: "مركز خبرة الأعصاب",
        glTitle: "Neurologie-Kompetenzzentrum",
        alText: "تقدم برامجنا للتصلب المتعدد وباركنسون والسكتة الدماغية رعاية متخصصة بتقنيات متقدمة لتعزيز الصحة وإدارة الأعراض وتحسين جودة الحياة...",
        glText: "Unsere Programme für Multiple Sklerose, Parkinson und Schlaganfall bieten spezialisierte Pflege mit fortschrittlichen Techniken, um die Gesundheit zu verbessern, Symptome zu verwalten und die Lebensqualität zu steigern...",
        link: allPaths?.FIFHTNEUROLOGYCENTRE
    },
    {
        img: service4,
        title: "PEDIATRIC REHABILITATION PROGRAM",
        text: "Our Pediatric Rehabilitation program is dedicated to helping children of all ages reach their highest potential. Pediatric physiotherapists are specifically trained to improve the lives...",
        alTitle: "برنامج إعادة التأهيل للأطفال",
        glTitle: "Pädiatrisches Rehabilitationsprogramm",
        alText: "برنامج إعادة التأهيل للأطفال مكرس لمساعدة الأطفال من جميع الأعمار على تحقيق إمكاناتهم القصوى. يتم تدريب أخصائيي العلاج الطبيعي للأطفال خصيصًا لتحسين حياة...",
        glText: "Unser pädiatrisches Rehabilitationsprogramm ist darauf ausgelegt, Kindern jeden Alters zu helfen, ihr höchstes Potenzial zu erreichen. Pädiatrische Physiotherapeuten sind speziell ausgebildet, um das Leben zu verbessern...",
        link: allPaths?.FIFHTPEDIATRIC
    },
    {
        img: service5,
        title: "FOOT LAB & GAIT ANALYSIS CENTRE OF EXPERTISE",
        text: "Your foot affects your gait all the way up to your hips and low back. Healthy feet and proper gait are at the root...",
        alTitle: "مختبر القدم ومركز تحليل المشية",
        glTitle: "Fußlabor & Ganganalyse-Kompetenzzentrum",
        alText: "قدميك تؤثر على مشيتك حتى الوركين والجزء السفلي من الظهر. الأقدام الصحية والمشية الصحيحة هي الأساس...",
        glText: "Ihr Fuß beeinflusst Ihren Gang bis hin zu Hüften und unterem Rücken. Gesunde Füße und ein richtiger Gang sind die Grundlage..."
    },
    {
        img: service6,
        title: "SPORTS MEDICINE CENTRE OF EXPERTISE",
        text: "There is a science behind the long success story of the Netherlands in the field of sports and Olympic games. To ensure sustainability...",
        alTitle: "مركز خبرة الطب الرياضي",
        glTitle: "Sportmedizin-Kompetenzzentrum",
        alText: "هناك علم وراء القصة الطويلة لنجاح هولندا في مجال الرياضة والألعاب الأولمبية. لضمان الاستدامة...",
        glText: "Hinter der langen Erfolgsgeschichte der Niederlande im Bereich Sport und Olympische Spiele steckt eine Wissenschaft. Um Nachhaltigkeit zu gewährleisten..."
    },
    {
        img: service7,
        title: "CLINICAL NUTRITION",
        text: "There is a famous saying that “You are what you eat”. Food is the fuel of your body. Research shows that dietary habits influence disease...",
        alTitle: "التغذية العلاجية",
        glTitle: "Klinische Ernährung",
        alText: "هناك قول مأثور يقول: 'أنت ما تأكل'. الغذاء هو وقود جسمك. تظهر الأبحاث أن العادات الغذائية تؤثر على المرض...",
        glText: "Es gibt ein bekanntes Sprichwort: 'Du bist, was du isst'. Nahrung ist der Treibstoff Ihres Körpers. Forschung zeigt, dass Ernährungsgewohnheiten Krankheiten beeinflussen..."
    },
    {
        img: service8,
        title: "WOMEN’S HEALTH CENTRE OF EXPERTISE",
        text: "Many musculoskeletal conditions and illnesses such as osteoporosis, pelvic floor dysfunction or pain, and urinary and bowel incontinence, in addition to female specific cancers...",
        alTitle: "مركز خبرة صحة المرأة",
        glTitle: "Kompetenzzentrum für Frauengesundheit",
        alText: "العديد من الحالات المرضية العضلية الهيكلية والأمراض مثل هشاشة العظام، خلل أو آلام قاع الحوض، وسلس البول والبراز، بالإضافة إلى السرطانات الخاصة بالنساء...",
        glText: "Viele muskuloskelettale Erkrankungen und Krankheiten wie Osteoporose, Beckenbodendysfunktion oder -schmerzen sowie Harn- und Stuhlinkontinenz, zusätzlich zu frauenspezifischen Krebserkrankungen..."
    },
    {
        img: service9,
        title: "AMSTERDAM CLINICS HEALTH CLUB",
        text: "Amsterdam Clinics has set out to make its dream come true. We dream of a healthy flourishing community with a true understanding and commitment to healthy...",
        alTitle: "نادي صحة عيادات أمستردام",
        glTitle: "Amsterdam Kliniken Gesundheitsclub",
        alText: "عيادات أمستردام تسعى لتحقيق حلمها. نحن نحلم بمجتمع صحي مزدهر بفهم حقيقي والتزام بالصحة...",
        glText: "Amsterdam Clinics hat sich vorgenommen, seinen Traum zu verwirklichen. Wir träumen von einer gesunden, blühenden Gemeinschaft mit einem echten Verständnis und Engagement für Gesundheit..."
    }
]
const latestNews = [
    {
        img: news1,
        title: "Corona Update",
        glTitle: "Corona Update",
        alTitle: "تحديث كورونا",
        text: "In order to continue our journey, which aims to preserve your health, the Amsterdam Clinics opened all of its branches with commitment to the rules of sterilization and disinfection from Sunday to Wednesday from 9:00 [...]",
        glText: "In order to continue our journey, which aims to preserve your health, the Amsterdam Clinics opened all of its branches with commitment to the rules of sterilization and disinfection from Sunday to Wednesday from 9:00 [...]",
        alText: "لمواصلة رحلتنا، التي تهدف إلى الحفاظ على صحتكم، فتحت عيادات أمستردام كل فروعها ملتزمة بقواعد التعقيم والتطهير من الأحد إلى الأربعاء من الساعة 9:00 [...]"
    },
    {
        img: news2,
        title: "Our measures against the coronavirus",
        glTitle: "Our measures against the coronavirus",
        alTitle: "تدابيرنا ضد فيروس كورونا",
        text: "In order to continue our journey, which aims to preserve your health, the Amsterdam Clinics opened all of its branches with commitment to the rules of sterilization and disinfection from Sunday to Wednesday from 9:00 [...]",
        glText: "In order to continue our journey, which aims to preserve your health, the Amsterdam Clinics opened all of its branches with commitment to the rules of sterilization and disinfection from Sunday to Wednesday from 9:00 [...]",
        alText: "لمواصلة رحلتنا، التي تهدف إلى الحفاظ على صحتكم، فتحت عيادات أمستردام كل فروعها ملتزمة بقواعد التعقيم والتطهير من الأحد إلى الأربعاء من الساعة 9:00 [...]"
    },
    {
        img: [news3, news4, news5, news6, news7],
        title: "Corporate program",
        glTitle: "Corporate program",
        alTitle: "برنامج الشركات",
        text: "#Amsterdam_Clinics Centers' workshop on the importance of physical preparation, warm-up, and relaxation, and their optimal practice. This workshop aimed at establishing communication between trainer, physiotherapist and player in order to provide the best service. #Amsterdam_Clinics [...]",
        glText: "#Amsterdam_Clinics Centers' workshop on the importance of physical preparation, warm-up, and relaxation, and their optimal practice. This workshop aimed at establishing communication between trainer, physiotherapist and player in order to provide the best service. #Amsterdam_Clinics [...]",
        alText: "ورشة عمل مراكز #Amsterdam_Clinics حول أهمية التحضير البدني والتمارين التسخينية والاسترخاء، وممارسة العمل الأمثل لها. تهدف هذه الورشة إلى تنمية التواصل بين المدرب والعلاج الطبيعي واللاعب من أجل تقديم أفضل خدمة. #Amsterdam_Clinics [...]"
    },
    {
        img: [news8, news9, news10],
        title: "Contract signing ceremony",
        glTitle: "Vertragsunterzeichnungszeremonie",
        alTitle: "حفل توقيع العقد",
        text: "Today we are celebrating the signing of an activity sponsoring contract between Amsterdam Clinics Centers, represented by Dr. Mohamed Zaghloul, and Alexandria Directorate, represented by Mr. Mohamed Abdel Aziz Haggag.  Hence, Amsterdam Clinics Centers have [...]",
        glText: "Heute feiern wir die Unterzeichnung eines Aktivitätssponsoringvertrags zwischen den Amsterdam Clinics Centers, vertreten durch Dr. Mohamed Zaghloul, und dem Alexandria Directorate, vertreten durch Herrn Mohamed Abdel Aziz Haggag.  Daher haben die Amsterdam Clinics Centers [...]",
        alText: "نحن نتطلع إلى رعاية هذه الأنشطة من خلال مراكز عيادات أمستردام، تحت إشراف الدكتور محمد زغلول، ومديرية الإسكندرية، تحت إشراف هيرن محمد عبد العزيز حجاج.  ضاهر هابن في مراكز عيادات أمستردام [...]"
    },
]
const aboutData = [
    {
        img: about1,
        title: "Who we are",
        glTitle: "Wer wir sind",
        alTitle: "من نحن",
        text: "The Dutch healthcare gate to your optimum well-being.Amsterdam Clinics is a...",
        glText: "Das niederländische Gesundheitstor zu Ihrem optimalen Wohlbefinden. Amsterdam Clinics ist ein...",
        alText: "البوابة الصحية الهولندية لصحتك المثلى. عيادات أمستردام هي...",
        link: allPaths?.FIFHTWHOWEARE
    },
    {
        img: about2,
        title: "Our Mission & Vision",
        glTitle: "Unsere Mission & Vision",
        alTitle: "مهمتنا ورؤيتنا",
        text: "Amsterdam Clinics aims to become a key player in the international healthcare industry...",
        glText: "Amsterdam Clinics strebt danach, ein wichtiger Akteur in der internationalen Gesundheitsbranche zu werden...",
        alText: "تهدف عيادات أمستردام إلى أن تصبح لاعباً رئيسياً في صناعة الرعاية الصحية الدولية...",
        link: allPaths?.FIFHTMISSIONANDVISION
    },
    {
        img: about3,
        title: "Our Core Values",
        glTitle: "Unsere Grundwerte",
        alTitle: "قيمنا الأساسية",
        text: "Amsterdam Clinics is here to put Your Health in Your Hands, with a...",
        glText: "Die Amsterdam Clinics sind hier, um Ihre Gesundheit in Ihre Hände zu legen, mit einem...",
        alText: "عيادات أمستردام هنا لوضع صحتك في يديك، مع...",
        link: allPaths?.FIFHTCOREVALUES
    },
    {
        img: about4,
        title: "Our Team",
        glTitle: "Unser Team",
        alTitle: "فريقنا",
        text: "‘Together we offer top care service for everyone’.Our team consists of highly...",
        glText: "„Zusammen bieten wir allen einen erstklassigen Pflegedienst“. Unser Team besteht aus hoch...",
        alText: "معًا نقدم خدمة رعاية من الدرجة الأولى للجميع’. يتكون فريقنا من...",
        link: allPaths?.FIFHTOURTEAMS
    },
    {
        img: about5,
        title: "Testimonials",
        glTitle: "Referenzen",
        alTitle: "الشهادات - التوصيات",
        text: "‘Together we offer top care service for everyone’.Our team consists of highly...",
        glText: "„Zusammen bieten wir allen einen erstklassigen Pflegedienst“. Unser Team besteht aus hoch...",
        alText: "معًا نقدم خدمة رعاية من الدرجة الأولى للجميع’. يتكون فريقنا من...",
        link: allPaths?.FIFHTTESTIMONIALS
    },
    {
        img: about6,
        title: "Careers",
        glTitle: "Karrieren",
        alTitle: "وظائف",
        text: "Amsterdam Clinics wants to be and remain an attractive employer for its employees...",
        glText: "Die Amsterdam Clinics möchten ein attraktiver Arbeitgeber für ihre Mitarbeiter sein und bleiben...",
        alText: "تريد عيادات أمستردام أن تكون وتبقى صاحب عمل جذاب لموظفيها...",
        link: allPaths?.FIFHTCAREERS
    },
];
const ourTeam = [
    {
        name: 'Claudette Haanstra – ten Hoope',
        glName: 'Claudette Haanstra – ten Hoope',
        alName: 'كلوديت هانسترا – تن هوبي',
        specialties: 'Oncology Physiotherapist, Edema Physiotherapist',
        glSpecialties: 'Onkologische Physiotherapeutin, Lymphödem-Physiotherapeutin',
        alSpecialties: 'أخصائية علاج طبيعي للأورام، أخصائية علاج طبيعي لاحتباس السوائل',
        img: doctor1,
    },
    {
        name: 'Menno Spoor',
        glName: 'Menno Spoor',
        alName: 'مينو سبور',
        specialties: 'Manual therapy, Sports physiotherapy',
        glSpecialties: 'Manuelle Therapie, Sportphysiotherapie',
        alSpecialties: 'العلاج اليدوي، العلاج الطبيعي الرياضي',
        img: doctor2,
    },
    {
        name: 'Mario Faro',
        glName: 'Mario Faro',
        alName: 'ماريو فارو',
        specialties: 'Manual therapy, Dry Needling, Pulmonary physiotherapist, Shockwave, Ultrasound',
        glSpecialties: 'Manuelle Therapie, Dry Needling, Pulmonaler Physiotherapeut, Stoßwelle, Ultraschall',
        alSpecialties: 'العلاج اليدوي، الإبر الجافة، أخصائي العلاج الطبيعي الرئوي، الموجات الصدمية، الموجات فوق الصوتية',
        img: doctor3,
    },
    {
        name: 'Hans Jutte',
        glName: 'Hans Jutte',
        alName: 'هانس جوتي',
        specialties: 'Manual therapy, Jaw therapy, Shoulder specialist, Headache specialist, Dry Needling',
        glSpecialties: 'Manuelle Therapie, Kiefertherapie, Schulterspezialist, Kopfschmerzspezialist, Dry Needling',
        alSpecialties: 'العلاج اليدوي، علاج الفك، أخصائي الكتف، أخصائي الصداع، الإبر الجافة',
        img: doctor4,
    },
    {
        name: 'Sabine Höhner',
        glName: 'Sabine Höhner',
        alName: 'سابين هوهنر',
        specialties: 'Tailbone pain, Dry Needling, Pregnancy-related pelvic complaints, Lifestyle advice',
        glSpecialties: 'Steißbeinschmerzen, Dry Needling, Schwangerschaftsbedingte Beckenschmerzen, Lebensstilberatung',
        alSpecialties: 'آلام عظم الذنب، الإبر الجافة، شكاوى الحوض المتعلقة بالحمل، نصائح نمط الحياة',
        img: doctor5,
    },
    {
        name: 'Tessa Van Roy',
        glName: 'Tessa Van Roy',
        alName: 'تيسا فان روي',
        about: "Tessa has a master’s degree in Physiotherapy and Rehabilitation Sciences” with selected topics in sports and manual therapy. During the coaching of the national team of volleyball, she developed special interest in shoulder problems, which came in handy while working at Kim Clijsters’ tennis academy. She now works for the high-performance centre of NOC*NSF (Netherlands Olympic Committee) in Eindhoven (Top support) and became a federal therapist for the Dutch equestrian sports for more than 6 years. Her passion for sports has always driven her to help athletes to reach the best possible performance.",
        glAbout: 'Tessa hat einen Masterabschluss in Physiotherapie und Rehabilitationswissenschaften mit ausgewählten Themen in Sport und manueller Therapie. Während des Coachings der Nationalmannschaft im Volleyball entwickelte sie ein besonderes Interesse an Schulterproblemen, was sich bei der Arbeit in der Tennisakademie von Kim Clijsters als nützlich erwies. Sie arbeitet jetzt im Hochleistungszentrum des NOC*NSF (Niederländisches Olympisches Komitee) in Eindhoven (Top Support) und wurde Bundestherapeutin für den niederländischen Reitsport seit mehr als 6 Jahren. Ihre Leidenschaft für den Sport hat sie immer dazu gebracht, Sportlern zu helfen, die bestmögliche Leistung zu erreichen.',
        alAbout: 'حصلت تيسا على درجة الماجستير في العلاج الطبيعي وعلوم إعادة التأهيل مع مواضيع مختارة في الرياضة والعلاج اليدوي. خلال تدريب فريق الكرة الطائرة الوطني، طورت اهتماماً خاصاً بمشاكل الكتف، مما كان مفيداً أثناء العمل في أكاديمية التنس التابعة لكيم كليسترز. تعمل الآن في مركز الأداء العالي للجنة الأولمبية الهولندية في أيندهوفن (Top Support) وأصبحت معالِجة فيدرالية لرياضات الفروسية الهولندية لأكثر من 6 سنوات. دفعها شغفها بالرياضة دائماً إلى مساعدة الرياضيين على الوصول إلى أفضل أداء ممكن.',
        img: doctor6,
    },
    {
        name: 'Cas Ensing',
        glName: 'Cas Ensing',
        alName: 'كاس إنسينج',
        heading: 'Neurological second opinion expert',
        glHeading: 'Experte für neurologische Zweitmeinungen',
        alHeading: 'خبير رأي ثاني في الأمراض العصبية',
        about: "Cas has more than 30-year experience in neurological rehabilitation, specialized in strokes, MS, and Parkinson’s, working with children and elderly people. Cas has participated in establishing the Dutch CVA network which is responsible for the quality and treatments of CVA patients. He is an expert in developmental motor skills, central neurological disorders, strokes, MS, Parkinson’s, and amputation.",
        glAbout: 'Cas hat mehr als 30 Jahre Erfahrung in der neurologischen Rehabilitation, spezialisiert auf Schlaganfälle, MS und Parkinson, arbeitet mit Kindern und älteren Menschen. Cas hat am Aufbau des niederländischen CVA-Netzwerks mitgewirkt, das für die Qualität und Behandlung von CVA-Patienten verantwortlich ist. Er ist Experte für Entwicklungsfähigkeiten, zentrale neurologische Störungen, Schlaganfälle, MS, Parkinson und Amputation.',
        alAbout: 'يمتلك كاس أكثر من 30 عامًا من الخبرة في إعادة التأهيل العصبي، متخصص في السكتات الدماغية والتصلب المتعدد وباركنسون، ويعمل مع الأطفال وكبار السن. شارك كاس في إنشاء شبكة CVA الهولندية التي تكون مسؤولة عن جودة العلاجات لمرضى CVA. هو خبير في المهارات الحركية التطويرية، والاضطرابات العصبية المركزية، والسكتات الدماغية، والتصلب المتعدد، وباركنسون، والبتر.',
        img: doctor7,
    },
    {
        name: 'Paul H.C. de Kort',
        glName: 'Paul H.C. de Kort',
        alName: 'بول إتش سي دي كورت',
        heading: 'Podiatry & Gait Analysis second opinion expert',
        glHeading: 'Experte für Podologie und Ganganalyse',
        alHeading: 'خبير رأي ثاني في طب الأقدام وتحليل المشي',
        about: "Paul is a podiatrist and human movement scientist. Working as a podiatrist since 2007, he realized the deficiencies in the field and decided to engage into human movement sciences. He completed his Master’s in Human Movement Sciences at Maastricht University in 2012, to become a pioneer in this new wholistic practice. Taking one further step, he studied functional patterns in order to gain more insight in human performance. In 2010, he has gradually expanded his practice in 13 locations across the Netherlands. Now he is running Gait Analysis Lab in Amsterdam Clinics and training therapists to become foot experts. He will participate in the training, diagnosis and treatment in Amsterdam Clinics Egypt, together with our qualified team.",
        glAbout: 'Paul ist Podologe und Wissenschaftler für menschliche Bewegung. Seit 2007 arbeitet er als Podologe und erkannte die Mängel in diesem Bereich, daher entschied er sich, sich in die Bewegungswissenschaften zu vertiefen. 2012 absolvierte er seinen Master in Bewegungswissenschaften an der Universität Maastricht, um Pionier in dieser neuen ganzheitlichen Praxis zu werden. Ein Schritt weiter, studierte er funktionelle Muster, um mehr Einblick in die menschliche Leistung zu erhalten. 2010 hat er seine Praxis in 13 Standorten in den Niederlanden schrittweise ausgebaut. Jetzt leitet er das Ganganalyseteam in den Amsterdam Clinics und bildet Therapeuten zu Fußexperten aus. Er wird an der Ausbildung, Diagnose und Behandlung in den Amsterdam Clinics Egypt zusammen mit unserem qualifizierten Team teilnehmen.',
        alAbout: 'بول هو اختصاصي طب الأقدام وعالم في حركة الإنسان. عمل كاختصاصي طب الأقدام منذ عام 2007، وأدرك النقص في هذا المجال وقرر الانخراط في علوم حركة الإنسان. أكمل درجة الماجستير في علوم حركة الإنسان في جامعة ماستريخت عام 2012، ليصبح رائدًا في هذه الممارسة الجديدة الشمولية. اتخذ خطوة أخرى بدراسة الأنماط الوظيفية لاكتساب المزيد من الفهم في الأداء البشري. في عام 2010، قام بتوسيع ممارسته تدريجيًا في 13 موقعًا في جميع أنحاء هولندا. الآن يدير مختبر تحليل المشي في عيادات أمستردام ويدرب المعالجين ليصبحوا خبراء في القدم. سيشارك في التدريب والتشخيص والعلاج في عيادات أمستردام في مصر، جنبًا إلى جنب مع فريقنا المؤهل.',
        img: doctor8,
    },
];
const rehabilitationData = [
    {
        img: rehabilitation1,
        title: "COPD Program",
        text: "If you have COPD, then your lungs are damaged, and you get less...",
        glTitle: "COPD-Programm",
        alTitle: "برنامج مرض الانسداد الرئوي المزمن",
        glText: "Wenn Sie COPD haben, sind Ihre Lungen beschädigt, und Sie bekommen weniger...",
        alText: "إذا كان لديك مرض الانسداد الرئوي المزمن، فإن رئتيك تتضرران، وتحصل على كمية أقل...",
    },
    {
        img: rehabilitation2,
        title: "Diabetics program",
        text: "Diabetes is a disease that occurs when your blood glucose, also called blood...",
        glTitle: "Diabetes-Programm",
        alTitle: "برنامج مرضى السكري",
        glText: "Diabetes ist eine Krankheit, die auftritt, wenn Ihr Blutzuckerspiegel, auch Blutzucker genannt, steigt...",
        alText: "السكري هو مرض يحدث عندما يرتفع مستوى الجلوكوز في الدم، والذي يسمى أيضًا سكر الدم...",
    },
    {
        img: rehabilitation3,
        title: "Geriatrics program",
        text: "The aging process can cause problems such as osteoporosis, poor gait, and...",
        glTitle: "Geriatrie-Programm",
        alTitle: "برنامج كبار السن",
        glText: "Der Alterungsprozess kann Probleme wie Osteoporose, schlechten Gang und...",
        alText: "يمكن أن يتسبب التقدم في العمر في مشاكل مثل هشاشة العظام، والمشي السيئ، و...",
    },
    {
        img: rehabilitation4,
        title: "Headache program",
        text: "Headache is a common complaint but the causes and types of pain can...",
        glTitle: "Kopfschmerz-Programm",
        alTitle: "برنامج علاج الصداع",
        glText: "Kopfschmerzen sind eine häufige Beschwerde, aber die Ursachen und Arten von Schmerzen können...",
        alText: "الصداع هو شكوى شائعة ولكن الأسباب وأنواع الألم يمكن أن...",
    },
    {
        img: rehabilitation5,
        title: "Corporate program",
        text: "Our prime purpose with corporate clients is to prevent injuries and improve performance...",
        glTitle: "Firmenprogramm",
        alTitle: "برنامج الشركات",
        glText: "Unser Hauptzweck mit Firmenkunden ist es, Verletzungen zu verhindern und die Leistung zu verbessern...",
        alText: "هدفنا الرئيسي مع العملاء من الشركات هو منع الإصابات وتحسين الأداء...",
    }
]
const neurologyData = [
    {
        img: neurology1,
        title: "Multiple Sclerosis (MS) Program",
        text: "MS is a debilitating condition that affects the central nervous system and disrupts...",
        glTitle: "COPD-Programm",
        alTitle: "برنامج مرض الانسداد الرئوي المزمن",
        glText: "Wenn Sie COPD haben, sind Ihre Lungen beschädigt, und Sie bekommen weniger...",
        alText: "إذا كان لديك مرض الانسداد الرئوي المزمن، فإن رئتيك تتضرران، وتحصل على كمية أقل...",
    },
    {
        img: neurology2,
        title: "Parkinson’s Program",
        text: "Parkinson’s disease is related to a loss of nerve cells in the brain...",
        glTitle: "Diabetes-Programm",
        alTitle: "برنامج مرضى السكري",
        glText: "Diabetes ist eine Krankheit, die auftritt, wenn Ihr Blutzuckerspiegel, auch Blutzucker genannt, steigt...",
        alText: "السكري هو مرض يحدث عندما يرتفع مستوى الجلوكوز في الدم، والذي يسمى أيضًا سكر الدم...",
    },
    {
        img: neurology3,
        title: "Stroke Program",
        text: "Stroke is a term used when a blood vessel in the brain is...",
        glTitle: "Geriatrie-Programm",
        alTitle: "برنامج كبار السن",
        glText: "Der Alterungsprozess kann Probleme wie Osteoporose, schlechten Gang und...",
        alText: "يمكن أن يتسبب التقدم في العمر في مشاكل مثل هشاشة العظام، والمشي السيئ، و...",
    }
]
const centreOfExpertiesTabs = [
    {
        title: 'Manual Physiotherapy',
        alTitle: 'العلاج الطبيعي اليدوي',
        glTitle: 'Manuelle Physiotherapie'
    },
    {
        title: 'Medical Taping',
        alTitle: 'التثبيت الطبي',
        glTitle: 'Medizinisches Taping'
    },
    {
        title: 'Shockwave Therapy',
        alTitle: 'العلاج بالموجات الصادمة',
        glTitle: 'Stoßwellentherapie'
    },
    {
        title: 'Osteopathy',
        alTitle: 'تقويم العظام',
        glTitle: 'Osteopathie'
    },
    {
        title: 'Dry Needling',
        alTitle: 'الإبر الجافة',
        glTitle: 'Dry Needling'
    },
    {
        title: 'Hydrotherapy',
        alTitle: 'العلاج المائي',
        glTitle: 'Hydrotherapie'
    },
]

export {
    menuItems,
    serviceData,
    latestNews,
    aboutData,
    ourTeam,
    rehabilitationData,
    neurologyData,
    centreOfExpertiesTabs
}